import { computed, nextTick, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { useChatStore } from '@/stores/chat'
import { isLoaded } from '@/types/load-state'
import type { ChatThread } from '@/types/chat'

/** Minimal handle a composer must expose so focus can be restored after a thread switch. */
interface ChatComposerHandle {
  focus: () => void
}

const composerRef = ref<ChatComposerHandle | null>(null)

/** Shared thread-switching wiring for the chat surfaces. */
export function useChatThreadSwitcher() {
  const chat = useChatStore()
  const route = useRoute()
  const router = useRouter()
  const { t } = useI18n()

  const threads = computed<ChatThread[]>(() => (isLoaded(chat.threads) ? chat.threads.value : []))

  function focusComposer(): void {
    void nextTick(() => composerRef.value?.focus())
  }

  function newChat(): void {
    if (route.name === 'chat') void router.push({ name: 'home' })
    else chat.startNewThread('chat')
    focusComposer()
  }

  return {
    chat,
    threads,
    composerRef,
    newChat,
    closedThreadMessage: t('chat.closedThreadMessage'),
  }
}
